import { ClaimsActivityLineOfBusinessTypeEnum } from "@app/projects/network-assessment/pci-dashboard/claims-activity";
import { QESSelect } from "@app/shared/qes-standards";
import { Project } from "@app/projects";
import { JSX } from "react";

interface ClaimsActivityLineOfBusinessFilterProps {
  disabled?: boolean;
  selectedLineOfBusiness: ClaimsActivityLineOfBusinessTypeEnum;
  setSelectedLineOfBusiness: (selectedLineOfBusiness: ClaimsActivityLineOfBusinessTypeEnum) => void;
  testId: string;
  validationTooltipContent?: string | JSX.Element;
  project: Project;
}

const ClaimsActivityLineOfBusinessFilter = (props: ClaimsActivityLineOfBusinessFilterProps): JSX.Element => {
  return (
    <QESSelect
      disabled={props.disabled}
      testId={props.testId}
      label="Line of Business"
      onChange={(e) => props.setSelectedLineOfBusiness(e.target.value as ClaimsActivityLineOfBusinessTypeEnum)}
      validationTooltipContent={!!props.validationTooltipContent && props.validationTooltipContent}
      value={props.selectedLineOfBusiness || ""}
    >
      {Object.values(ClaimsActivityLineOfBusinessTypeEnum)
        .filter((lineOfBusinessType) => {
          if (lineOfBusinessType == ClaimsActivityLineOfBusinessTypeEnum.TRICARE && !props.project.showTricareClaimsVolumeColumn) {
            return false;
          }
          else if (lineOfBusinessType == ClaimsActivityLineOfBusinessTypeEnum.VA && !props.project.showVaClaimsVolumeColumn) {
            return false;
          }
          else {
            return true;
          }
        })
        .map((lineOfBusinessType, index) => (
        <option
          key={index}
          value={lineOfBusinessType}
        >
          {lineOfBusinessType}
        </option>
      ))}
    </QESSelect>
  );
}

export default ClaimsActivityLineOfBusinessFilter;
